import React from "react";
import { Flex, Text } from "rebass/styled-components";
import { FaVideo } from "react-icons/fa";

import { ISelection } from "../../types";
import {
  WelcomeModalOverlay,
  WelcomeModalContent,
  WelcomeModalTitle,
  WelcomeModalSubtitle,
  WelcomeModalButton,
  ClipTitleSection,
  ClipTitleLabel,
  ClipTitleInput,
  TotalDuration,
} from "../../styledComponents";

export interface ITitleModalProps {
  show: boolean;
  onClose: () => void;
  clipTitle: string;
  setClipTitle: (title: string) => void;
  selections: ISelection[];
  getSelectionDuration: (selection: ISelection) => number;
  tickRate: number;
  isSubmitting?: boolean;
  onSubmit: () => void;
}

export const TitleModal: React.FC<ITitleModalProps> = ({
  show,
  onClose,
  clipTitle,
  setClipTitle,
  selections,
  getSelectionDuration,
  tickRate,
  isSubmitting,
  onSubmit,
}) => {
  if (!show) return null;

  const totalDuration = Math.round(
    selections.reduce((acc, s) => acc + getSelectionDuration(s), 0) / tickRate,
  );

  return (
    <WelcomeModalOverlay onClick={onClose}>
      <WelcomeModalContent onClick={(e) => e.stopPropagation()}>
        <WelcomeModalTitle>Almost there!</WelcomeModalTitle>
        <WelcomeModalSubtitle>
          <FaVideo size={14} />
          Give your clip a title (optional)
        </WelcomeModalSubtitle>

        <ClipTitleSection style={{ marginTop: "16px" }}>
          <ClipTitleLabel>Clip Title</ClipTitleLabel>
          <ClipTitleInput
            type="text"
            placeholder="Enter a title for your clip..."
            value={clipTitle}
            onChange={(e) => setClipTitle(e.target.value)}
            maxLength={100}
            autoFocus
          />
        </ClipTitleSection>

        <TotalDuration style={{ marginTop: "16px" }}>
          <Text fontSize="12px" color="#557077">
            Total video length:
          </Text>
          <Text fontSize="14px" fontWeight="600" color="#4dbd94">
            {totalDuration}s ({selections.length} segment
            {selections.length !== 1 ? "s" : ""})
          </Text>
        </TotalDuration>

        <Flex style={{ gap: "12px", marginTop: "20px" }}>
          <WelcomeModalButton
            onClick={onClose}
            style={{
              background: "transparent",
              border: "1px solid #3a4a52",
              color: "#8fa9af",
              flex: 1,
            }}
          >
            Cancel
          </WelcomeModalButton>
          <WelcomeModalButton
            onClick={onSubmit}
            disabled={isSubmitting}
            style={{ flex: 1 }}
          >
            {isSubmitting ? "Creating..." : "Create Clip"}
          </WelcomeModalButton>
        </Flex>
      </WelcomeModalContent>
    </WelcomeModalOverlay>
  );
};

export default TitleModal;
